import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const WaveEventButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 30px;
`;

export const WaveEventInfoWrapperGiantStyles = media.giant`
    max-width: 400px;
`;

export const WaveEventInfoWrapperTabletStyles = media.tablet`
    max-width: 100%;
    width: 100%;
    overflow: auto;
    max-height: inherit;
    padding: 16px 20px 30px;
    height: auto;
    &:hover {
        overflow: auto;
    }
`;

const WaveEventInfoWrapper = styled.div`
  max-width: 500px;
  background-color: #ebeef5;
  padding: 30px;
  max-height: 100vh;
  height: 100%;
  min-height: 100%;
  margin: 0 auto;
  position: relative;
  pointer-events: all;
  overflow: auto;
  ${WaveEventInfoWrapperGiantStyles};

  ${WaveEventInfoWrapperTabletStyles};
`;

export default WaveEventInfoWrapper;
